import * as yup from 'yup';
import _ from 'lodash';
import { ShippingIncomingConf } from './common/ShippingIncoming.conf';
import { ShippingDutyPaidIncomingConf } from './common/ShippingDutyPaidIncoming.conf';
const customFields = (fields) =>
  fields.map((field) => ({
    ...field,
    disabled: true,
    type: 'text',
  }));

const CommonConf = {
  schema: {
    email: yup
      .string()
      .nullable()
      .email('Please enter a valid email')
      .required('Email is required'),
  },
  defaultValues: {
    email: '',
  },
  fields: [
    {
      id: 'id_yacht',
      name: 'id_yacht',
      type: 'text',
      label: 'Yacht',
      required: true,
      disabled: true,
      xs: 12,
      sm: 6,
    },
    {
      id: 'email',
      name: 'email',
      type: 'text',
      label: 'Email',
      required: true,
      xs: 12,
      sm: 6,
    },
    {
      id: 'requested_date',
      name: 'requested_date',
      type: 'date',
      label: 'Arrival Date',
      required: true,
      disabled: true,
      xs: 12,
      sm: 6,
    },
    {
      id: 'check_out_date',
      name: 'check_out_date',
      type: 'date',
      label: 'Delivery Date',
      required: false,
      disabled: true,
      xs: 12,
      sm: 6,
    },
  ],
};

export const SendEmailFormConf = {
  'INCOMING PARCEL': {
    schema: yup.object({
      ...CommonConf.schema,
    }),
    defaultValues: {
      ...CommonConf.defaultValues,
    },
    fields: _.concat(
      CommonConf.fields,
      customFields(ShippingIncomingConf.fields.slice(0, 5))
    ),
  },
  'INCOMING CUSTOMS PARCEL': {
    schema: yup.object({
      ...CommonConf.schema,
    }),
    defaultValues: {
      ...CommonConf.defaultValues,
    },
    fields: _.concat(
      CommonConf.fields,
      customFields(ShippingDutyPaidIncomingConf.fields.slice(0, 7))
    ),
  },
};
